import { render } from "./message-face.vue?vue&type=template&id=70bdd750&scoped=true&ts=true"
import script from "./message-face.vue?vue&type=script&lang=ts"
export * from "./message-face.vue?vue&type=script&lang=ts"

import "./message-face.vue?vue&type=style&index=0&id=70bdd750&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bdd750"]])

export default __exports__